<template>
  <ButtonTemplateMicInput :text-button="t('reset')" :on-click="resetContext">
    <template #icon-handler>
      <IconRefresh />
    </template>
  </ButtonTemplateMicInput>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import IconRefresh from '@/components/icons/IconRefresh.vue';
import { useSocketStore } from '@/stores/socket';
import { useToastStore } from '@/stores/toast.js';

const toastStore = useToastStore();
const socketStore = useSocketStore();

const { t } = useI18n();

const resetContext = () => {
  socketStore.sendMessageIc();
  toastStore.info(t('context_reset_success'));
};
</script>
